import { render, staticRenderFns } from "./TellThemCollegePrepModal.vue?vue&type=template&id=c4dec3d0&scoped=true&"
import script from "./TellThemCollegePrepModal.vue?vue&type=script&lang=js&"
export * from "./TellThemCollegePrepModal.vue?vue&type=script&lang=js&"
import style0 from "./TellThemCollegePrepModal.vue?vue&type=style&index=0&id=c4dec3d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dec3d0",
  null
  
)

export default component.exports